var _sift = window._sift = window._sift || [];
(function ($) {

  var fraudscore = {
    includeFraudScoreTracking: function() {
      // User id should be the email being used.
      // Security fix: Use session-based cookie instead of persistent cookie to avoid storing PII long-term
      var userId = (typeof site !== 'undefined' && site.userInfoCookie && typeof site.userInfoCookie.getValue === 'function')
        ? site.userInfoCookie.getValue('email')
        : '';
      var sessionId = getCookie('ngglobal');
      var snippetKey = Drupal.settings.siftscience.js_snippet_key;

      _sift.push(['_setAccount', snippetKey]);
      _sift.push(['_setUserId', userId]);
      _sift.push(['_setSessionId', sessionId]);
      _sift.push(['_trackPageview']);
    }
  };

  var getCookie = function(cookieName) {
    var cookieValue = '';
    var beginIndex = 0;
    var endIndex = 0;
    var cookies = document.cookie;
    if (cookies.length > 0) {
      beginIndex = cookies.indexOf(cookieName + '=');
      if (beginIndex != -1) {
        beginIndex += cookieName.length + 1;
        endIndex = cookies.indexOf(';', beginIndex);
        if (endIndex == -1) {
          endIndex = cookies.length;
        }
        cookieValue = unescape(cookies.substring(beginIndex, endIndex));
      }
    }
    return cookieValue;
  };

  $(document).ready(function() {
    if (getCookie('csr_logged_in') !== 1) {
      fraudscore.includeFraudScoreTracking();
    }
  });

})(jQuery);
